// @ts-nocheck
import React, {useRef, useState} from "react";
import useOutsideClick from "../../../hooks/useOutsideClick";

import styled from "styled-components";
import {DateRange} from 'react-date-range';
import * as locales from 'react-date-range/dist/locale';
import './nativeStyles/styles.css'
import './nativeStyles/default.css'

export const CustomDatePicker = (props: any) => {
    const [show, setShow] = useState(false)
    const myRef = useRef()

    const dateInitial = {
        startDate: new Date(),
        endDate: null,
        key: 'selection'
    }

    const [date, setDate] = useState([
        dateInitial
    ])

    useOutsideClick(myRef, () => {
        if (show) setShow(false)
    })


    return (
        <Styled className={"custom-date-input"} ref={myRef}>
            <div style={{background: props.bg}} onClick={_ => setShow(!show)} className="">
                Все время
            </div>

            {show ?
                <div className='calendar'>
                    <DateRange
                        editableDateInputs={false}
                        onChange={item => props.onChange(item.selection)}
                        moveRangeOnFirstSelection={false}
                        ranges={[props.date]}
                        endDatePlaceholder={"По"}
                        startDatePlaceholder={"С"}
                        locale={locales.ru}
                    />
                </div>
                : ''}
        </Styled>
    )
}
const Styled = styled.div`
  position: relative;
  cursor: pointer;
  z-index: 10000000;

  button {
    &:hover {
      background: unset

    }

    &:focus {
      background: unset

    }

  }

  .calendar {
    z-index: 10000000000000;
    position: absolute;
    width: 260px;
    height: max-content;
    top: 112%;
    left: -20px;
    box-shadow: 0 3px 6px 0 rgba(39, 45, 59, 0.2)

  }
`
